import type { TrackData } from '@/types';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export const TrackApiService = Symbol('TrackApiService');

export interface TrackApiService {
    track(dataTrack: TrackData): Promise<boolean>;
}

@injectable()
export class TrackApiServiceImpl extends PsHttpService implements TrackApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    track(dataTrack: TrackData) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/tracking/add',
            data: {
                ...dataTrack,
                module_type: 'EUREKA',
            },
        }).then((res) => {
            return res.status as boolean
        })
    }
}
